module.exports = __webpack_public_path__ + "img/lcdEquipment.a5e072db.jpg";